import type { GridRowSelectionModel } from '@mui/x-data-grid'
import { useEffect, useState } from 'react'
import type { MediaGrid, StaleMediaPaginationRequest } from '../types'
import { useGetStaleMedia } from './useGetStaleMedia'

const initialPaginationRequest: StaleMediaPaginationRequest = {
  Filter: '',
  Skip: 0,
  Take: 10,
  OrderBy: 'verifiedDate',
  OrderByOrder: 'asc',
}

export function useMediaGrid(): MediaGrid {
  const [paginationRequest, setPaginationRequest] =
    useState<StaleMediaPaginationRequest>(initialPaginationRequest)
  const [selectionModel, setSelectionModel] = useState<GridRowSelectionModel>(
    [],
  )
  const [searchText, setSearchText] = useState('')

  const staleMedia = useGetStaleMedia(paginationRequest)
  const { gridMode, rows } = staleMedia

  useEffect(() => {
    if (gridMode === 'server') {
      setPaginationRequest((prev) => ({
        ...prev,
        Filter: searchText,
      }))
    }
  }, [searchText, gridMode])

  useEffect(() => {
    if (gridMode === 'client') {
      setPaginationRequest((prev) => ({
        ...prev,
        Skip: 0,
        Take: rows.totalCount,
      }))
    }
  }, [gridMode, rows.totalCount])

  return {
    paginationRequest,
    setPaginationRequest,
    selectionModel,
    setSelectionModel,
    searchText,
    setSearchText,
    staleMedia,
  }
}
